import request from '@/utils/request'; // 小区信息

export function fetchCommunityInfoVo(data) {
  return request({
    url: '/pmsdevice/api/homePage/getCommunityInfoVo',
    method: 'post',
    data: data
  });
} // 统计今日告警

export function countTodayAlarm(data) {
  return request({
    url: '/pmsdevice/api/homePage/countTodayAlarm',
    method: 'get',
    params: data
  });
} // 设备告警15天

export function halfMonthAlarm(data) {
  return request({
    url: '/pmsservice/api/spot/deviceDayList',
    method: 'post',
    data: data
  });
} // 设备状态统计

export function fetchDeviceStatus(data) {
  return request({
    url: '/pmsdevice/api/homePage/findDeviceStatusStatistics',
    method: 'post',
    data: data
  });
} // 设备状态统计(新)

export function findELESStatusStatistics(data) {
  return request({
    url: '/pmsdevice/api/homePage/findELESStatusStatistics',
    method: 'post',
    data: data
  });
} // 数字井盖

export function fetchManholeCoverList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findWellCoverStatusStatistics',
    method: 'post',
    data: data
  });
} // 垃圾箱状态

export function fetchDustbinList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findDustbinStatusStatistics',
    method: 'post',
    data: data
  });
} // 电梯设备状态列表

export function fetchElevatorStatusList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findElevatorStatusList',
    method: 'post',
    data: data
  });
} // 二氧化碳浓度列表

export function fetchCarbonDioxideList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findCarbonDioxideList',
    method: 'post',
    data: data
  });
} // 二氧化碳近七天浓度趋势

export function fetchDustbinSevenDayList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findDustbinSevenDayList',
    method: 'post',
    data: data
  });
} // 停车场进出流水近七天折线图

export function fetchParkingInOutSevenDayList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findParkingInOutSevenDayList',
    method: 'post',
    data: data
  });
} // 门禁流水近七天折线图

export function fetchDoorFlowSevenDayList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findDoorFlowSevenDayList',
    method: 'post',
    data: data
  });
} // 信报箱昨日和今日24小时折线图

export function fetchFastBox24HourList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findFastBox24HourList',
    method: 'post',
    data: data
  });
} // 水表昨日和今日24小时折线图

export function fetchWaterMeter24HourList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findWaterMeter24HourList',
    method: 'post',
    data: data
  });
} // 党建情况

export function fetchPartyBuildingInfo(data) {
  return request({
    url: '/pmsdevice/api/homePage/getPartyInformation',
    method: 'post',
    data: data
  });
} // 党校活动列表

export function fetchPartyBuildingList(data) {
  return request({
    url: '/pmsdevice/api/homePage/findPartActiveList',
    method: 'post',
    data: data
  });
} // 门禁

export function fetchBuildingList(data) {
  return request({
    url: '/pmsservice/api/building/list',
    method: 'post',
    data: data
  });
}
export function selectTrashInfo(data) {
  return request({
    url: '/pmsdevice/api/trashInfo/getTrashInfo',
    method: 'post',
    data: data
  });
}
export function fetchExternalInfo(data) {
  return request({
    url: '/pmsdevice/api/deviceExpand/devExpand',
    method: 'post',
    data: data
  });
} // 健康驿站

export function fetchHealthySevenDayList(data) {
  return request({
    url: '/pmsdevice/api/homePage/healthySevenDayList',
    method: 'post',
    data: data
  });
} // 党员年龄结构

export function fetchPartyAgeCount(data) {
  return request({
    url: '/pmsdevice/api/homePage/getPartyAgeCount',
    method: 'post',
    data: data
  });
} // 获取停车总数

export function remainSpaceNum(data) {
  return request({
    url: '/pmsservice/api/parkingRecord/remainSpaceNum',
    method: 'post',
    data: data
  });
}